import DataSensitivityLabel from './dataSensitivityLabel';

const ColumnCheckbox: React.FC<{
  column: any;
  type: string;
  isChecked: boolean;
  onCheck: (value: string) => void;
}> = ({ column, type, isChecked, onCheck }) => {
  const handleCheck = () => {
    onCheck(column);
  };

  return (
    <label
      htmlFor={column.key}
      className={`flex items-center gap-3 p-3 rounded-lg border transition-all duration-200 cursor-pointer ${
        isChecked
          ? 'bg-blue-50 border-blue-200 shadow-sm'
          : 'bg-white border-gray-200 hover:bg-gray-50 hover:border-gray-300'
      }`}
    >
      <input
        id={column.key}
        type="checkbox"
        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
        checked={isChecked}
        onChange={handleCheck}
      />
      <span className="flex-1 text-sm font-medium text-gray-900">{column.title}</span>
      <DataSensitivityLabel type={type} />
    </label>
  );
};

export default ColumnCheckbox;
